"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getProps = exports.getProps = function getProps(state) {
  if (state) {
    if (state.isState) {
      return state.toJS();
    } else {
      return state;
    }
  } else {
    return {};
  }
};